import request from "../Config/axios";
// -----------------------------------------------------------
export const GetById_Reserve_User_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve_User/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Reserve_User_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve_User/GetAll`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Paging_Reserve_User_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve_User/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const CheckUserExistingAndAddToReserve_Reserve_User_Api = async (params) => {
    
    const { data } = await request.postMultiPart(
        `/Reserve_User/CheckUserExistingAndAddToReserve`,
        params
    );
    return data;

    // const { data } = await request.post(
    //     `/Reserve_User/CheckUserExistingAndAddToReserve`,
    //     params
    // );
    // return data;
};
// -----------------------------------------------------------
export const RemoveUserFromReserve_Reserve_User_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve_User/RemoveUserFromReserve`,
        params
    );
    return data;
};
// -----------------------------------------------------------
